import { Button, Typography } from "@mui/material";
import { useAtom } from "jotai";
import React from "react";
import { useHistory } from "react-router-dom";
import { profilePicModal } from "../../jotai/atoms.jotai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import AndesModal from "../AndesModal/AndesModal";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ProfilePicAlertModal: React.FC<Props> = ({ open, onClose }) => {
  const history = useHistory();
  const [, setProfilePicModal] = useAtom(profilePicModal);

  if (!open) return null;

  return (
    <AndesModal
      message="Aún no cargaste tu foto de perfil"
      handleClose={onClose}
    >
      <Typography variant="body1" sx={{ my: 2 }}>
        *También podés editar tu nombre!
      </Typography>
      <Button
        onClick={() => {
          history.push("/dashboard/profile");
          setProfilePicModal(true);
          onClose();
        }}
        sx={{ width: "100%" }}
        variant="contained"
        endIcon={<FontAwesomeIcon icon={faBolt} />}
      >
        Cargar ahora!
      </Button>
    </AndesModal>
  );
};
